import Grid from "@mui/material/Grid";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import CircleIcon from "@mui/icons-material/Circle";
import makeStyles from "@mui/styles/makeStyles";
import styles from 'assets/jss/Scan/scanStyle';
import {scanLevels} from 'helpers/scanLevels'

const useStyles = makeStyles(styles)
const ScanStates = (props) => {
    const {nfcError, nfcStatus} = props
    const classes = useStyles()
    const states = [
        {
            title: 'اتصال NFC و همگام سازی دستگاه با موبایل',
            stateNumber: scanLevels.NFC_READING_STARTED
        },
        {
            title: 'دریافت تست ها',
            stateNumber: scanLevels.NFC_FINISHED_OK
        },
        {
            title: 'ساخت گزارش',
            stateNumber: scanLevels.SENDING_TO_SERVER
        }
    ]
    return (
        <Grid item xs={12} mt={nfcError?'6px':'26px'} >
            {states.map((state) => (
                <Grid className={classes.lineContainer} container>
                    <Grid item className={classes.center} xs={1}>
                        {nfcStatus >= state.stateNumber ? (
                            <CheckIcon className={classes.doneTik}/>
                        ) : nfcError && nfcStatus <= state.stateNumber ? (
                            <ClearIcon className={classes.errorIcon}/>
                        ) : (
                            <CircleIcon
                                className={`${nfcStatus >= state.stateNumber
                                    ? classes.done
                                    : nfcStatus === state.stateNumber - 1
                                        ? classes.processingIcon
                                        : ''
                                }
                                ${classes.circleList}`}
                            />
                        )}
                    </Grid>
                    <Grid
                        className={`${nfcStatus >= state.stateNumber
                            ? classes.done
                            : nfcStatus === state.stateNumber - 1&& !nfcError
                                ? classes.processing
                                : ''
                        }
                            ${classes.normalState} ${nfcError && nfcStatus < state.stateNumber ? classes.errorText : ''
                        }`}
                        item
                        xs={11}
                    >
                        {state.title}
                    </Grid>
                </Grid>

            ))}
        </Grid>
    )
}
export default ScanStates